import styled from 'styled-components'

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 32px;
`

export const MenuContainer = styled.section`
  display: flex;
  flex-direction: column;
`
